// extracted by mini-css-extract-plugin
export default {"wrapper":"VerificationWarning_wrapper__PKozb"};